<template>
    <div class="cad-export">
        <div class="canvas-container">
            <!-- 导出按钮 -->
            <div class="export-actions">
                <div class="export-button"><ButtonField text="导出为CAD文件" @click="exportToCad" primary width="100%"/></div>
                <div class="export-button"><ButtonField text="下载JSON文件" @click="downloadJson" secondary width="100%"/></div>
<!--                <div class="export-button"><ButtonField text="加载示例数据" primary @click="loadSampleData" width="100%"/></div>-->
                <div class="export-button"><ButtonField text="返回上一页" @click="goback" secondary width="100%"/></div>
            </div>

            <!-- 画布预览 -->
            <div class="canvas-preview" v-if="showCanvas">
                <h3 style=" color:#fff;">图形预览</h3>
                <canvas ref="previewCanvas" :width="canvasWidth" :height="canvasHeight"></canvas>
            </div>

            <!-- 预览区域 -->
            <div class="preview">
                <h3>数据预览</h3>
                <pre>{{ formattedJson }}</pre>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
// import {fetchCadExport} from "../api/detection";
import {fetchCadExport} from "@/views/expand/api/detection";
export default {
    name: 'CadExport',
    data() {
        return {
            cadData: [
                {
                    name: '点A',
                    nums: 41.92,
                    nums1: 10,
                    diameter: 3,
                    points: [
                        { longitude: 118.53692588419979, latitude: 32.98925963444192 }
                    ]
                },
                {
                    name: '线B',
                    nums: 20,
                    nums1: 10,
                    diameter: 5,
                    points: [
                        { longitude:  118.54006759256711, latitude: 33.006765860765256 },
                        { longitude: 118.54037414790601, latitude: 33.0067522848429 }
                    ]
                }
            ],
            loading: false,
            showCanvas: true,
            canvasWidth: 600,
            canvasHeight: 400
        };
    },
    computed: {
        formattedJson() {
            return JSON.stringify(this.cadData, null, 2);
        }
    },
    mounted() {
        this.drawPreview();
    },
    created() {
        const str = localStorage.getItem('cad_facilitems');
        if (str) {
            try {
                this.facilitiesInArea = JSON.parse(str);
                this.cadData = this.wrapToCadData(this.facilitiesInArea);
            } catch (e) {
                console.error('解析失败', e);
            }
            // 可选：立刻清掉
            localStorage.removeItem('CAD_FACILITIES');
        }
    },
    methods: {
        wrapToCadData(src) {
            return src.map((item) => ({
                name: item.name,
                nums: item.nums ?? 0,
                nums1: item.nums1 ?? 0,
                diameter: item.diameter ?? 5,
                points: item.points.map(p => ({
                    longitude: p.longitude,
                    latitude: p.latitude
                }))
            }));
        },
        goback(){
            this.$router.go(-1);
        },
        async exportToCad() {
            this.loading = true;
            try {
                const res = await fetchCadExport(this.cadData)
                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `cad_export_${Date.now()}.dxf`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                this.$message.success('CAD文件导出成功！');
            } catch (error) {
                console.error('导出失败:', error);
                this.$message.error('导出失败: ' + (error.response?.data?.message || error.message));
            } finally {
                this.loading = false;
            }
        },

        downloadJson() {
            const dataStr = JSON.stringify(this.cadData, null, 2);
            const dataBlob = new Blob([dataStr], { type: 'application/json' });
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `cad_data_${Date.now()}.json`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        drawPreview() {
            const canvas = this.$refs.previewCanvas;
            if (!canvas) return;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

            /* ---------- 1. 经纬度 → Web-Mercator（米） ---------- */
            const mercator = (lon, lat) => {
                const x = lon * 20037508.34 / 180;
                let y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
                y = y * 20037508.34 / 180;
                return [x, y];
            };

            const pts = [];
            this.cadData.forEach(item =>
                item.points.forEach(p => pts.push(mercator(p.longitude, p.latitude)))
            );

            /* ---------- 2. 找范围 ---------- */
            const padding = 40;
            const xs = pts.map(v => v[0]), ys = pts.map(v => v[1]);
            const minX = Math.min(...xs), maxX = Math.max(...xs);
            const minY = Math.min(...ys), maxY = Math.max(...ys);
            const scaleX = (this.canvasWidth  - 2 * padding) / Math.max(1, maxX - minX);
            const scaleY = (this.canvasHeight - 2 * padding) / Math.max(1, maxY - minY);
            const scale = Math.min(scaleX, scaleY);

            /* ---------- 3. 绘制 ---------- */
            this.cadData.forEach(item => {
                const mPts = item.points.map(p => {
                    const [mx, my] = mercator(p.longitude, p.latitude);
                    return {
                        x: padding + (mx - minX) * scale,
                        y: this.canvasHeight - padding - (my - minY) * scale
                    };
                });

                if (mPts.length === 1) {
                    // 点
                    ctx.beginPath();
                    ctx.arc(mPts[0].x, mPts[0].y, item.diameter * 2, 0, Math.PI * 2);
                    ctx.fillStyle = 'rgba(255,0,0,.6)';
                    ctx.fill();
                    ctx.strokeStyle = '#d00'; ctx.stroke();
                    ctx.fillStyle = '#000';
                    ctx.font = '12px Arial';
                    ctx.fillText(`${item.name}(${item.nums})`, mPts[0].x + 8, mPts[0].y - 8);
                } else {
                    // 线
                    ctx.beginPath();
                    ctx.moveTo(mPts[0].x, mPts[0].y);
                    for (let i = 1; i < mPts.length; i++) ctx.lineTo(mPts[i].x, mPts[i].y);
                    ctx.strokeStyle = '#00f'; ctx.lineWidth = 2; ctx.stroke();
                    // 文字
                    const mid = mPts.reduce((a, b) => ({ x: a.x + b.x, y: a.y + b.y }));
                    mid.x /= mPts.length; mid.y /= mPts.length;
                    ctx.fillStyle = '#000'; ctx.font = '12px Arial';
                    ctx.fillText(`${item.name}(${item.nums})`, mid.x, mid.y - 10);
                }
            });
        }
    },
    watch: {
        cadData: {
            deep: true,
            handler() {
                this.drawPreview();
            }
        }
    }
};
</script>

<style scoped>
.cad-export {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.data-input {
    border: 1px solid #ddd;
    padding: 20px;
    border-radius: 5px;
}

.data-item {
    border: 1px solid #eee;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 4px;
}

.point-item {
    display: flex;
    gap: 10px;
    margin: 10px 0;
    align-items: center;
}

input {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-right: 10px;
}

button {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 10px;
    margin-top: 5px;
}

button:hover {
    background-color: #0056b3;
}

button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.preview {
    border: 1px solid #ddd;
    padding: 20px;
    border-radius: 5px;
    background-color: #f8f9fa;
    width: 40%;
}

pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
    max-height: 350px;
    overflow-y: auto;
}

.canvas-preview {
    border: 1px solid #a9a9a9;
    padding: 20px;
    border-radius: 5px;
    width: 40%;
}

canvas {
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    width: 100%;
}
.export-button{
    margin: 1.5rem;
}
.canvas-container{
    display: flex;
    justify-content: space-between;
}
</style>